import { postRoute } from "./client"

export type FeedbackKind = "idea" | "bug" | "question"

export interface FeedbackTicketCreated {
  success: true
  ticket: { id: string; number: string; status: "new" }
}

export const submitFeedbackRoute = postRoute<FeedbackTicketCreated>("/api/feedback")
